'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components'; // @ts-expect-error svgs are untyped modules

import blobsImageUrl from 'bender-url!../../../img/storefront-header-blobs.svg';
import globalNavHeight from 'nav-meta/global-nav-height';
import { GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
const StyledHeaderWrapper = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, ["backgroundColor", "gradientAngle", "startGradientColor", "endGradientColor"]);

  return /*#__PURE__*/_jsx("header", Object.assign({}, rest));
}).withConfig({
  displayName: "StyledHeaderWrapper",
  componentId: "sc-2x9pn9-0"
})(["padding:0 16px;width:100%;background-color:", ";background-image:url(", "),linear-gradient( ", ",", ",", " );background-position:center center;background-repeat:no-repeat;background-size:auto 100%;@media screen and (max-width:", "){background-image:linear-gradient( ", ",", ",", " );}&.sticky{padding:0 0 ", ";}"], props => props.backgroundColor, blobsImageUrl, props => props.gradientAngle || '-303deg', props => props.startGradientColor, props => props.endGradientColor, GRID_BREAKPOINT_SMALL, props => props.gradientAngle || '-303deg', props => props.startGradientColor, props => props.endGradientColor, globalNavHeight);
StyledHeaderWrapper.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  gradientAngle: PropTypes.string,
  startGradientColor: PropTypes.string.isRequired,
  endGradientColor: PropTypes.string.isRequired
};
export default StyledHeaderWrapper;